import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, componentId, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton } from "../../elements";
import "./style.scss";
import { gtag } from "../../utils";
const DealerMap = props => {
    const { rendering, fields, page } = props;
    const {
        button,
        title,
        userCountText,
        backgroundImage,
        leftRightIcon,
        handIcon,
        tips
    } = fields;
    const titleNode = useRef();
    const nodeRef = useRef();
    const [isShow, setIsShow] = useState(true)
    const scrollContainerRef = useRef(null);
    const isMobile = mobileIs()

    const onScroll = () => {
        let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
        if (titleNode.current.getBoundingClientRect().top < pageHeight) {
            titleNode.current.setAttribute('animate', 'fadeIn');
        } else {
            titleNode.current.setAttribute('animate', 'fadeOut');
        }

        if (nodeRef.current.getBoundingClientRect().top < pageHeight - 300) {
            let timer = setTimeout((v) => {
                clearTimeout(timer)
                setIsShow(false);
            }, 5000)
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
        const setInitialScroll = () => {
            if (isMobile && scrollContainerRef.current) {
                const contentWidth = scrollContainerRef.current.scrollWidth;
                const containerWidth = scrollContainerRef.current.clientWidth;
                scrollContainerRef.current.scrollLeft = (contentWidth - containerWidth) / 2; // 中间
            }
        };

        setInitialScroll();
        window.addEventListener("resize", setInitialScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", setInitialScroll); // 清理监听
        };
    }, []);

    const rootClasses = classNames("c-dealer-map", getOverallSettingsClasses(fields));
    const rootId = componentId(rendering);
    return (
        <div className={rootClasses} datasourceid={rendering.dataSource} ref={nodeRef} id={rootId}>
            <div className="c-dealer-map__title">
                <div className="c-dealer-map__title__content" ref={titleNode}>
                    <RichText className="c-dealer-map__title__content__title" tag="div" field={title} />
                </div>
            </div>
            <div className="c-dealer-map__text">
                <div className="c-dealer-map__text__countries">
                    <RichText className="c-dealer-map__text__countries__text" tag="div" field={userCountText} />
                </div>
            </div>
            <div className="c-dealer-map__image">
                <div className="c-dealer-map__image__content" ref={scrollContainerRef}>
                    <BackgroundImage {...backgroundImage} className="c-dealer-map__image__bg"></BackgroundImage>
                </div>
                {button && <div className="button">
                    <PrimaryButton {...button?.fields} />
                </div>}
            </div>

            {isShow && <div className="hand-animate-content">
                <BackgroundImage {...leftRightIcon} className="left-right-icon" />
                <BackgroundImage {...handIcon} className="hand-icon" />
            </div>}
            {isShow && <RichText tag="div" className="tips" field={tips} />}
        </div>
    );
};

export default DealerMap;